export const NumberRegex = /^\d{10}$/;
export const EmailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i;
export const PasswordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+{}:'<>?])[A-Za-z\d!@#$%^&*()_+{}:'<>?]{8,}$/;

export const menuName = {
    timeTracking: 'Time Tracking',
    settings: 'Settings',
    workHistory: 'Work History',
    addVacation: 'Add Vacation',
    vacationManagement: 'Vacation Mgnt.'
}

export const menuLanguageKeyMapping = {
    'Dashboard': 'menu_dashboard',
    'Client': 'menu_client_mgnt',
    'Packages': 'menu_packages',
    'User Mgnt.': 'menu_user_mgnt',
    'Users': 'menu_user_mgnt_users',
    'User Types': 'menu_user_mgnt_user_type',
    'Designations': 'menu_user_mgnt_designations',
    'Birthday Calendar': 'menu_birthday_calendar',
    'Stammdaten': 'menu_stammdaten',
    'Customer': 'menu_stammdaten_customer',
    'Projects': 'menu_stammdaten_projects',
    'Documents': 'menu_stammdaten_documents',
    'Warehouse Mgnt.': 'menu_warehouse_mgnt',
    'Lager': 'menu_warehouse_mgnt_lager',
    'WH Place Management': 'menu_warehouse_mgnt_wh_place_management',
    'Inventory Mgmt.': 'menu_warehouse_mgnt_inventory_mgmt',
    'Equipment list': 'menu_warehouse_mgnt_equipment_list',
    'Equipment History': 'menu_warehouse_mgnt_equipment_history',
    'Time Tracking': 'menu_time_tracking',
    'All User Time Tracking': 'organizer_timetracking_allusertimetracking',
    'Individual Time Tracking': 'organizer_timetracking_individualtimetracking',
    'DATEV Export': 'menu_datev_export',
    'Construction Diary': 'menu_construction_diary',
    'Vacation Mgnt.': 'menu_vacation_mgnt',
    'All Leaves': 'organizer_vacationmanagement_all_leaves',
    'All Leaves Admin': 'organizer_vacationmanagement_all_leaves',
    'Add Leave': 'organizer_vacationmanagement_leave',
    'Requested Leave': 'organizer_vacationmanagement_requested',
    'City': 'menu_utility_city',
    'Support-Zeiterfassung': 'menu_support_tracking',
    'Erfassung': 'menu_support_erfassung',
    'Verlauf': 'menu_support_verlauf',
    'Tätigkeiten': 'menu_support_einstellungen',
    'Settings': 'menu_settings',
    'General Setting': 'menu_settings_general_setting',
    'Add Vacation': 'menu_settings_add_vacation',
    'Work History': 'menu_settings_work_history',
    'Company Detail': 'menu_settings_company_detail',
    'KI-Einstellungen': 'menu_settings_ai',
    'Shift Mgnt.': 'menu_shift_mgnt',
    'Plan Mgnt.': 'menu_shift_mgnt_plan_mgnt',
    'Employee Shift': 'menu_shift_mgnt_employee_shift',
    'Vertragsmanager': 'menu_contract_manager',
    'Contract Dashboard': 'menu_contract_dashboard',
    'Contract List': 'menu_contract_list',
    'Contract Calendar': 'menu_contract_calendar',
    'Contract Categories': 'menu_contract_categories',
    'Contract AI': 'menu_contract_ai',
    'Contract Chat': 'menu_contract_chat',
    'Token Admin': 'menu_token_admin',
};